import React, { useContext } from 'react';
import { CircularProgress, Typography } from '@mui/material';
import classnames from 'classnames';
import styled from 'styled-components';

import { t } from '../../../../../../utils/i18next';
import { storeContext } from '../../../../../context';
import { paymentTypes } from '../../../../../../constants/mixpanel';
import { StyledPaymentItemContainer } from '../../../../../theme/styledElements';
import { OfferItemPropType } from '../../../../../propTypes';
import PopoverButton from '../PopoverButton';
import PaymentItem from '../PaymentItem/PaymentItem';
import PaymentItemData from '../PaymentItem/PaymentItemData';
import PaymentItemButton from '../PaymentItem/PaymentItemButton';

const translationBase = 'payables.total_side_bar.assist';

const StyledLoaderContainer = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

const OfferItemFooter = props => {
  const {
    payable,
    userState,
    translations: { currentLanguage }
  } = useContext(storeContext);

  const { selectBills, isLoadingOffer, limitedOfferPaymentAmount } = payable;

  const { duration, hasValidOffer } = props;
  const { PAYMENT, ASSIST_PP, FINANCING_PP } = paymentTypes;
  const { MAKE_A_PAYMENT } = PaymentItem.paymentTypes;
  const payableAmount = payable.aNextPayment;

  const amountToPay = selectBills
    ? payable.selectableNextPayment
    : parseFloat(payable.aNextPayment);

  const getPaymentOptions = () => {
    const options = [];
    const paymentButtonType = payable.isFinancedOffer
      ? FINANCING_PP
      : ASSIST_PP;

    options.push({
      text: 'payables.payment_options.pay_now',
      amount: amountToPay,
      paymentButtonType: PAYMENT
    });

    options.push({
      text: 'payables.payment_options.pay_over_time',
      amount: limitedOfferPaymentAmount,
      duration,
      servicefee: payable.offerServiceFee,
      paymentButtonType: paymentButtonType
    });

    return options;
  };

  const getSelectMoreBillsMessage = () =>
    selectBills &&
    !hasValidOffer && (
      <>
        <p />
        <Typography variant="h6" className="title" color={'textPrimary'}>
          {t(`${translationBase}.manage-bills`)}
        </Typography>
        <br />
        <Typography className="subTitle" color={'textPrimary'}>
          {t(`${translationBase}.add-more`)}
        </Typography>
      </>
    );

  const getButtonType = () => {
    return !selectBills || hasValidOffer ? (
      <PopoverButton
        buttonText={t(`${translationBase}.pp_options`)}
        buttonColor={'primary'}
        paymentOptions={getPaymentOptions()}
      />
    ) : (
      <PaymentItemButton
        type={MAKE_A_PAYMENT}
        buttonColor={'primary'}
        amount={payableAmount}
      />
    );
  };

  userState.set(
    'paymentItemPopoverType',
    PaymentItem.popoverTypes.ANCHOR_TO_TOP
  );

  return (
    <>
      <StyledPaymentItemContainer
        data-testid="mobile-offer-item"
        className={classnames('paymentItem', 'mobileOfferItem', {
          hidden: isLoadingOffer
        })}
      >
        <PaymentItemData type={MAKE_A_PAYMENT} amount={payable.aNextPayment}>
          {getButtonType()}
        </PaymentItemData>
        {getSelectMoreBillsMessage()}
      </StyledPaymentItemContainer>
      {isLoadingOffer && (
        <StyledLoaderContainer
          className={'loaderContainer'}
          data-testid="dynamic-offer-loader"
        >
          <CircularProgress className={'loader'} />
        </StyledLoaderContainer>
      )}
    </>
  );
};

OfferItemFooter.propTypes = OfferItemPropType;

export default OfferItemFooter;
